import { FCPData, INPData, LCPData, LSData } from "./types";

type Metrics = {
    LCP: LCPData[];
    LS: LSData[];
    INP: INPData[];
    navigation: PerformanceNavigationTiming[];
    FCP: FCPData[];
    resource: PerformanceResourceTiming[];
    history: { url: string; start: number }[];
};

class MetricsStorage {
    private metrics: Metrics = {
        LCP: [],
        LS: [],
        INP: [],
        navigation: [],
        FCP: [],
        resource: [],
        history: [],
    };
    private flushInterval: number;
    private flushTimer: ReturnType<typeof setTimeout> | null = null;
    private flushCallback: (metrics: Metrics) => void;

    constructor(flushIntervalMs: number, flushCallback: (metrics: Metrics) => void) {
        this.flushInterval = flushIntervalMs;
        this.flushCallback = flushCallback;

        if (typeof window !== 'undefined') {
            window.addEventListener('load', () => this.flush(), { once: true });
            window.addEventListener('beforeunload', () => this.flush());
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden') {
                    this.flush();
                }
            });
        }
    }

    addMetric<K extends keyof Metrics>(type: K, data: Metrics[K][number]) {
        (this.metrics[type] as Array<Metrics[K][number]>).push(data);
        if (!this.flushTimer) {
            this.startFlushTimer();
        }
    }

    private startFlushTimer() {
        this.flushTimer = setTimeout(() => {
            this.flush();
        }, this.flushInterval);
    }

    flush() {
        if (Object.values(this.metrics).some(arr => arr.length > 0)) {
            this.flushCallback(this.metrics);
            this.metrics = {
                LCP: [],
                LS: [],
                INP: [],
                navigation: [],
                FCP: [],
                resource: [],
                history: [],
            };
        }
        if (this.flushTimer) {
            clearTimeout(this.flushTimer);
            this.flushTimer = null;
        }
    }
}

export default MetricsStorage;